import React from 'react'
import type { FollowMeShareTicket } from '@core/Areas/FollowMe/types'
import type { Ticket } from '@core/Areas/AccountActivity/types'
import { SummaryLine } from '@mobi/betslip/Components/Common/SummaryLine'

export const FavouriteNumbers: React.FC<{ ticket: Ticket | FollowMeShareTicket }> = ({
  ticket,
}) => {
  return (
    <div>
      {ticket.legs[0].selections.map(({ header, selectionDetails }) => (
        <SummaryLine key={header} left={header} right={selectionDetails[0].selectionString} />
      ))}
    </div>
  )
}
